import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { BaseComponent, SearchComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent, WmsSplitPaneComponent, WmsSplitPanelComponent, LiveWidgetsFieldsListComponent, WmsDialogComponent } from '@wms/components';
import { LiveWidgetSettingsService } from '@wms/app/services/liveWidgetsSettings/live-widget-settings.service';
import { FilterPipe } from '@wm/components-base';
import {
  clone, cloneDeep, extend, find, findIndex, forEach, get, head, includes, indexOf, initial, isEmpty, last, omit, reject, remove, slice, some, startsWith, isArray,
  split, toString, upperCase, map, filter } from 'lodash-es';
import { FormsModule } from '@angular/forms';
import { LiveWidgetUtilsService } from '@wms/app/services/liveWidgetUtils/live-widget-utils.service';
import { StudioUtils, fetchPropertiesMapColumns, getFieldsForService, getMatchModes, getWidgetRolesArrayFromStr, prepareFieldDefs, resetObjectWithEmptyValues, stringStartsWith, prettifyLabel, isQuoteNotPresent, isNoDoubleQuoteNotPresent, isValidHtml } from '@wms/app/core';
import { ProjectService, TypeFactoryService, CustomExtensionService } from '@wms/app/services';
import { EventHandlerComponent, PropertiesTemplateComponent } from '@wms/properties-panel';
import { BasicComponent } from "@wms/app/design-container/table-designer/basic/basic.component";
import { isDateTimeType, isDefined } from "@wm/core";
import { BaseVariableService } from '@wms/variables';
import { FieldsListComponent } from "@wms/app/components/fields-list/fields-list.component";
import { RowComponent } from "@wms/app/design-container/table-designer/row/row.component";
import { StyleComponent } from "@wms/app/design-container/table-designer/style/style.component";
import { SecurityComponent } from '@wms/components';
import { ActionsBasicComponent } from '../runtime/components/actions-basic/actions-basic.component';
import { WmsIconSelectorComponent } from '@wms/app/components/wms-icon-selector/wms-icon-selector.component';
import { WidgetDesignerComponent } from "@wms/app/design-container/widget-designer.component";
import { setDisplayFlags } from '@wm/design-runtime';
import { WmsExpressionErrorDirective } from '@wms/app/directives/wms-expression-error/wms-expression-error.directive';
import {ColumnsFilterPipe} from "@wms/app/columns-filter-pipe";

@Component({
  selector: 'wms-table-designer',
  standalone: true,
  templateUrl: './table-designer.component.html',
  styleUrls: ['./table-designer.component.less'],
  imports: [
    CommonModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    TabsModule,
    SearchComponent,
    WmsSplitPanelComponent,
    WmsSplitPaneComponent,
    TooltipModule,
    FilterPipe,
    SearchComponent,
    FormsModule,
    PropertiesTemplateComponent,
    BasicComponent,
    FieldsListComponent,
    LiveWidgetsFieldsListComponent,
    RowComponent,
    StyleComponent,
    SecurityComponent,
    ActionsBasicComponent,
    WmsDialogComponent,
    WmsIconSelectorComponent,
    EventHandlerComponent,
    WmsExpressionErrorDirective,
    ColumnsFilterPipe

  ],
  providers: [LiveWidgetSettingsService]
})
export class TableDesignerComponent extends BaseComponent implements OnInit {

  @Input() propPanelInfo: any;
  @Input() activeWidgetType: any;
  @Output() handleClose = new EventEmitter<any>();
  liveWidgetSettingsService: LiveWidgetSettingsService;
  liveWidgetUtils: LiveWidgetUtilsService;
  typeService: TypeFactoryService;
  variableService: BaseVariableService;
  toUpperCase = upperCase;
  convertToString = toString;
  indexOf = Array.prototype.indexOf;
  everyoneRole = ['Everyone'];
  customPipeOptions: any;
  pipesArr: any;
  matchModes: any;
  displayfieldArray: any;
  datafieldArray: any;
  groupbyDisplayOptions: any;
  filterDatafieldArray: any;
  filterDisplayfieldArray: any;
  groupList: any;
  events: any;
  selectedFieldColumns: any;
  fieldsList: any;
  contentOptions: any;
  formatter: any;
  isBoundToLiveVariable: any;
  customExtensionService: CustomExtensionService;
  isPrefabType = false;
  private dialogDesigner: WidgetDesignerComponent;
  columnsKey: string = '';
  actionSearchKey: string = '';
  private selectedIndex: number | undefined;
  private selectedComponentType: string;

  constructor() {
    super();
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService);
    this.customExtensionService = inject(CustomExtensionService);
    this.liveWidgetUtils = inject(LiveWidgetUtilsService);
    this.typeService = inject(TypeFactoryService);
    this.variableService = inject(BaseVariableService);
    this.dialogDesigner = inject(WidgetDesignerComponent);
  }

  ngOnInit(): void {
    this.liveWidgetSettingsService.initSettings(this.propPanelInfo, this.activeWidgetType).then(success => {
      this.initTableDesigner();
      (this.customExtensionService.getCustomFormatters() as Promise<any>).then((response: any) => {
        if (response) {
          this.customPipeOptions = response;
          this.pipesArr = Object.keys(response);
        }
      });
      this.isBoundToLiveVariable = get(this.liveWidgetSettingsService.activeWidgetScope.variable, 'category') === 'wm.LiveVariable';
      this.liveWidgetSettingsService.isDateTimeType = isDateTimeType;
      this.liveWidgetSettingsService.widgetTypes = this.liveWidgetUtils.getViewModeWidgets();
    })
  }

  searchColumns($event: any) {
    this.columnsKey = $event.searchKey;
  }

  //Method to add new group
  addNewGroup() {
    let groupNames = map(this.getExistingGroupNames(this.liveWidgetSettingsService.headerConfig), 'field'),
      groupKey = this.liveWidgetUtils.getCustomFieldKey(undefined, undefined, 'group', groupNames),
      config = {
        'displayName': prettifyLabel(groupKey),
        'field': groupKey,
        'columns': [],
        'isGroup': true,
        'textAlignment': 'center',
        'accessroles': this.everyoneRole
      };
    this.insertNewGroup(this.liveWidgetSettingsService.headerConfig, config);
    this.updateSelectedComponent(config, 'field');
    this.liveWidgetSettingsService.headerConfig = [...this.liveWidgetSettingsService.headerConfig];
    this.updateGroupList();
  }

  updateGroupList() {
    this.groupList = this.getExistingGroupNames(this.liveWidgetSettingsService.headerConfig, this.liveWidgetSettingsService.selectedComponent.field.field);
    this.setParentGroupName(this.liveWidgetSettingsService.headerConfig, this.liveWidgetSettingsService.selectedComponent.field);
  }

  //Function to insert a new group. New group will be inserted above the selected column/ group
  insertNewGroup(headerConfig: any, newGroup: any) {
    let index = findIndex(headerConfig, { 'field': this.liveWidgetSettingsService.selectedComponent.field.field });
    //If the selected group/ column is found, insert new group before that. Else, search in the inner nodes
    if (index > -1) {
      //Move the selected column/ group to new group
      newGroup.columns.push(this.liveWidgetSettingsService.selectedComponent.field);
      headerConfig.splice(index, 1, newGroup);
      return false;
    }
    forEach(headerConfig, (config: any) => {
      if (config.isGroup) {
        this.insertNewGroup(config.columns, newGroup);
      }
    });
    return;
  }

  getColDefCopy(gridColumnDef: Array<any>) {
    let _gridColumnDef: Array<any> = [];
    forEach(gridColumnDef, (colDef: any) => {
      _gridColumnDef.push(clone(colDef));
    });
    return _gridColumnDef;
  }

  /*function to initialize the grid designer with the required data*/
  initTableDesigner() {
    var gridColumnDef: any = [],
      gridButtonDef,
      gridRowActionDef,
      gridRowDef,
      defaultButtons = this.liveWidgetUtils.getLiveWidgetButtons('GRID'),
      defaultRowActions = this.liveWidgetUtils.getLiveWidgetButtons('GRIDROW'),
      activeWidget = this.liveWidgetSettingsService.activeWidgetScope,
      newVal,
      rowActionColExists,
      rowActionField,
      _fields: any;
    /*variable bound with the grid*/
    newVal = this.getGridData();

    this.fieldsList = this.liveWidgetSettingsService.getFieldsList();
    this.liveWidgetSettingsService.componentDefnObject.enableRowExpansion = isEmpty(activeWidget.rowDef) ? 'false' : 'true';
    gridColumnDef = activeWidget?.fullFieldDefs ? [...activeWidget?.fullFieldDefs] : [];
    gridButtonDef = activeWidget?.actions ? [...activeWidget?.actions] : [];
    gridRowActionDef = activeWidget?.rowActions ? [...activeWidget?.rowActions] : [];
    gridRowDef = isEmpty(activeWidget.rowDef) ? this.liveWidgetUtils.getRowDef({ 'expandicon': 'wi wi-expand-more', 'collapseicon': 'wi wi-chevron-right', 'class': 'btn-icon' }) : cloneDeep(activeWidget.rowDef);
    this.liveWidgetSettingsService.contentOptions = StudioUtils.getContentOptions(activeWidget.widgettype).options;

    /*loop through each columnDef for defaultValues in the property form*/
    forEach(gridColumnDef, (colDef) => {
      this.liveWidgetUtils.splitDimension(colDef, 'width');
      colDef.field = colDef.field || 'custom';
      colDef.editWidgetType = colDef.editWidgetType === 'typeahead' ? 'autocomplete' : colDef.editWidgetType;
      if (isDefined(colDef.searchable)) {
        let boolean = JSON.parse(colDef.searchable);
        colDef.searchable = boolean
      } else {
        colDef.searchable = colDef.type !== 'blob' && colDef.type !== 'clob';
      }
      // if(colDef.filterwidget === 'text' && !isDefined(colDef.filterinputtype)){
      //   colDef.filterinputtype = 'text';
      // }
      // if(colDef.editWidgetType === 'text' && !isDefined(colDef.edit)){
      //   colDef.filterinputtype = 'text';
      // }
      if(!isDefined(colDef.sortable)){
        colDef.sortable = true;
      }
      if (colDef?.$attrs?.get('sortable.bind') && ('bind:'+ colDef?.$attrs?.get('sortable.bind') != colDef.sortable)) {
        colDef.sortable = 'bind:' + colDef?.$attrs?.get('sortable.bind');
      }
      if (colDef?.$attrs?.get('readonly.bind') && ('bind:'+ colDef?.$attrs?.get('readonly.bind') != colDef.readonly)) {
        colDef.readonly = 'bind:' + colDef?.$attrs?.get('readonly.bind');
      }
      if (!isDefined(colDef.caseinsensitive)) {
        colDef.caseinsensitive = false;
      }
      this.setAccessRoles(colDef);
      if (colDef.field === 'rowOperations' && colDef.type === 'custom') {
        colDef.isRowOperation = true;
      }
      if (colDef?.$attrs?.get('caption.bind') && ('bind:'+ colDef?.$attrs?.get('caption.bind') != colDef.displayName)) {
        colDef.displayName = 'bind:' + colDef?.$attrs?.get('caption.bind');
      }
      this.liveWidgetSettingsService.onExpressionChange(colDef);
    });

    rowActionColExists = some(gridColumnDef, { 'field': 'rowOperations', type: 'custom' });
    if (!rowActionColExists) {
      rowActionField = find(activeWidget.fieldDefs, { 'field': 'rowOperations', type: 'custom' });
      if (rowActionField) {
        omit(rowActionField, ['operations', 'opConfig']);
        rowActionField.isRowOperation = true;
        this.liveWidgetUtils.splitDimension(rowActionField, 'width');
        gridColumnDef.push(rowActionField);
      }
    }
    /*loop through each buttonDef for defaultValues in the property form*/
    forEach(gridButtonDef, (buttonDef: any) => {
      buttonDef.include = true;
      this.setAccessRoles(buttonDef);
    });

    /*loop through each buttonDef for defaultValues in the property form*/
    forEach(gridRowActionDef, (rowActionDef: any) => {
      rowActionDef.include = true;
      this.setAccessRoles(rowActionDef);
    });

    this.isBoundToLiveVariable = get(this.liveWidgetSettingsService.activeWidgetScope.variable, 'category') === 'wm.LiveVariable';
    if (!newVal) {
      /* set the default initialized fieldDefs found from grid*/
      this.liveWidgetSettingsService.componentDefnObject.field = gridColumnDef;
      /* set the default initialized buttonDefs found from grid*/
      this.liveWidgetSettingsService.componentDefnObject.button = gridButtonDef;
      this.liveWidgetSettingsService.componentDefnObject.rowActions = gridRowActionDef;
      this.liveWidgetSettingsService.componentDefnObject.rowDef = gridRowDef;
      this.populateHeaderConfig(this.liveWidgetSettingsService.headerConfig);
      this.selectFirstComponents();
      return;
    }
    var data = newVal.data || newVal,
      propertiesMap = newVal.propertiesMap,
      properties,
      propertiesConfig: any;

    /*if the data is type json object, make it an array of the object*/
    if (!Array.isArray(data)) {
      data = [data];
    }

    /* if properties map is existed then fetch the column configuration for all nested levels using util function */
    if (propertiesMap) {
      propertiesConfig = fetchPropertiesMapColumns(propertiesMap);
      properties = [resetObjectWithEmptyValues(propertiesConfig)];
    } else {
      properties = data;
    }

    /*prepare default fieldDefs for the data provided*/
    if (activeWidget.isBoundToServiceVariable || activeWidget.isBoundToWebSocketVariable || activeWidget.isBoundToWidget) {
      _fields = getFieldsForService(properties);
    } else {
      _fields = prepareFieldDefs(properties);
    }
    this.liveWidgetSettingsService.filterFields = [];

    //Loop over the existing fields present in table
    forEach(gridColumnDef, (colDef) => {
      var _colDef = find(_fields, { field: colDef.field });
      if (_colDef) { //If field is not a custom field, push it to filter fields and remove from _fields
        colDef.relatedEntityName = get(propertiesConfig, [colDef.field, 'relatedEntityName']);
        colDef.showdropdownon = colDef.showdropdownon || 'default';
        colDef.dataentrymode = colDef.dataentrymode || 'default';
        colDef.autoclose = colDef.autoclose || 'outsideClick';
        colDef.editinputtype = colDef.editinputtype || 'text';
        colDef.filterinputtype = colDef.filterinputtype || 'text';
        this.liveWidgetSettingsService.filterFields.push(colDef.field);
      }
    });

    _fields = reject(_fields, (colDef) => {
      return includes(this.liveWidgetSettingsService.filterFields, colDef.field);
    });
    //Limiting the number of extra fields to 1000 to prevent rendering freeze
    _fields = slice(_fields, 0, 100);

    /*loop over the extra fields to prepare final column defs object*/
    forEach(_fields, (colDef) => {
      var propertiesField;

      this.liveWidgetSettingsService.filterFields.push(colDef.field);
      if (propertiesMap && propertiesConfig) {
        propertiesField = propertiesConfig[colDef.field];
        colDef.type = propertiesField.type;
        colDef.primaryKey = propertiesField.isPrimaryKey;
        colDef.generator = propertiesField.generator;
        colDef.relatedEntityName = propertiesField.relatedEntityName;
        colDef.showdropdownon = 'default';
        colDef.dataentrymode = 'default';
        colDef.autoclose = 'outsideClick';
        colDef.editWidgetType = this.liveWidgetUtils.getEditModeWidget(colDef);
        colDef.showineditmode    = true;
        colDef.readonly = colDef.relatedEntityName ? !colDef.primaryKey : includes(['identity', 'uniqueid', 'sequence'], colDef.generator);
        colDef.filterwidget = this.liveWidgetUtils.getDataTableFilterWidget(colDef.type || 'string');
        colDef.required = propertiesField.notNull && !colDef.readonly;
      }
      colDef.searchable = colDef.type !== 'blob' && colDef.type !== 'clob';
      colDef.sortable = true;
      colDef.show = true;
      colDef.accessroles = this.everyoneRole;
      colDef.editinputtype = 'text';
      colDef.filterinputtype = 'text';
      if (!isDefined(colDef.pcDisplay)) {
        colDef.pcDisplay = colDef.tabletDisplay = colDef.mobileDisplay = false;
      }
      gridColumnDef.push(colDef);
      if (!find(this.liveWidgetSettingsService.headerConfig, {'field': colDef.field})) {
        this.liveWidgetSettingsService.headerConfig.push({
          'field': colDef.field
        });
      }

    });

    /*prepare final list of fieldDefs for the designer*/
    this.liveWidgetSettingsService.componentDefnObject.field = gridColumnDef;
    setDisplayFlags(this.liveWidgetSettingsService.componentDefnObject.field);
    //Remove the predefined columns like multiselect and radioselect
    remove(this.liveWidgetSettingsService.headerConfig, { 'isPredefined': true });
    this.populateHeaderConfig(this.liveWidgetSettingsService.headerConfig);
    /* set the default initialized buttonDefs found from grid*/
    this.liveWidgetSettingsService.componentDefnObject.button = this.getColDefCopy(gridButtonDef);
    this.liveWidgetSettingsService.componentDefnObject.rowActions = this.getColDefCopy(gridRowActionDef);
    this.liveWidgetSettingsService.componentDefnObject.rowDef = gridRowDef;
    this.contentChange(gridRowDef.content, true);
    /*Add the default buttons and set the include to false*/
    forEach(defaultButtons, (button: any) => {
      if (!some(this.liveWidgetSettingsService.componentDefnObject.button, { 'key': button.key })) {
        button.include = !!this.liveWidgetSettingsService.shadowProperties[button.key];
        button.accessroles = this.everyoneRole;
        if (button.key === 'addNewRow') {
          button.include = !!this.liveWidgetSettingsService.shadowProperties.insertrow;
        }
        this.liveWidgetSettingsService.componentDefnObject.button.push(button);
      }
    });

    forEach(defaultRowActions, (action: any) => {
      if (!some(this.liveWidgetSettingsService.componentDefnObject.rowActions, { 'key': action.key })) {
        action.accessroles = this.everyoneRole;
        action.include = !!this.liveWidgetSettingsService.shadowProperties[action.key];
        this.liveWidgetSettingsService.componentDefnObject.rowActions.push(action);
      }
    });

    forEach(this.liveWidgetSettingsService.headerConfig,(field:any)=>{
      if(field.isGroup){
        let ele: any;
        ele = this.liveWidgetSettingsService?.markupManager?.getActiveMarkupEl()?.find('wm-table-column-group[name="'+field.field+'"]');
        let caption:string= ele[0].getAttribute('caption')
        if(caption.startsWith('bind:')){
          field.displayName = caption;
        }
      }
    });

    this.selectFirstComponents();
  }

  //Return fields from TypeUtils if not bound to live variable
  getGridData() {
    var activeWidget = this.liveWidgetSettingsService.activeWidgetScope;
    if (activeWidget.isBoundToServiceVariable || activeWidget.isBoundToWebSocketVariable || activeWidget.isBoundToWidget) {
      return this.typeService.getFieldsForExpr(activeWidget.binddataset, { 'getFieldInfo': true, 'filter': 'terminal' });
    }
    return activeWidget.gridVariable;
  }

  showPropertyInSubGroup = (property: any) => {
    return this.liveWidgetSettingsService.activeWidgetScope?.widgetProps[property]?.showindesigner;
  }

  //function to add new custom component
  addCustomComponent = (componentType: any) => {
    var customKey, proxyType = componentType, prefix, newComponent: any, newField;
    if (componentType === 'field') {
      customKey = this.liveWidgetUtils.getCustomFieldKey(this.liveWidgetSettingsService.componentDefnObject[componentType], 'field', 'customField');
      newField = {
        'field': customKey,
        'type': 'string',
        'sortby': '',
        'displayName': 'Custom Column',
        'pcDisplay': true,
        'mobileDisplay': false,
        'tabletDisplay': false,
        'allowBinding': true,
        'accessroles': this.everyoneRole,
        'sortable': this.liveWidgetSettingsService.shadowProperties.enablesort,
        'searchable': false,
        'show': true,
        'caseinsensitive': false
      };
      // TODO: check this by removing spread operator after getting unique instance of liveWidgetSettingService change done by Vaishavi
      this.liveWidgetSettingsService.componentDefnObject[componentType] = [...this.liveWidgetSettingsService.componentDefnObject[componentType], newField];
      this.liveWidgetSettingsService.headerConfig = [...this.liveWidgetSettingsService.headerConfig, newField];
      this.liveWidgetSettingsService.updateSelectAll('field', 'pcDisplay');
      this.liveWidgetSettingsService.updateSelectAll('field', 'mobileDisplay');
      this.liveWidgetSettingsService.updateSelectAll('field', 'tabletDisplay');
    } else {
      prefix = componentType === 'button' ? 'customButton' : 'customRow';
      customKey = this.liveWidgetUtils.getCustomFieldKey(this.liveWidgetSettingsService.componentDefnObject[componentType], 'key', prefix);
      newComponent = {
        'key': customKey,
        'displayName': 'Custom ' + componentType,
        'title': 'Custom ' + componentType,
        'value': '',
        'iconclass': '',
        'class': 'btn-secondary',
        'show': 'true',
        'include': true,
        'action': null,
        'accessroles': this.everyoneRole
      };
      if (componentType === 'rowActions') {
        proxyType = 'button';
        newComponent.widgetType = 'button';
        newComponent.class = 'btn-transparent';
        newComponent.displayName = '';
        newComponent.iconclass = 'wi wi-settings';
        if (!this.liveWidgetSettingsService.componentDefnObject.rowActions.length) {
          this.liveWidgetSettingsService.componentDefnObject.field.push(this.liveWidgetUtils.getRowOperationsColumn());
        }
      } else {
        newComponent.widgetType = 'button';
        newComponent.position = 'footer';
        newComponent.shortcutkey = '';
      }
      this.liveWidgetSettingsService.componentDefnObject[componentType].push(newComponent);
      this.liveWidgetSettingsService.updateSelectAll('button', 'include');
    }
    this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject[componentType][this.liveWidgetSettingsService.componentDefnObject[componentType].length - 1], proxyType);
  };

  //function to update selected component on click of a column in UI
  updateSelectedComponent = (componentDef: any, componentType: any, index?: any, $event?: any) => {
    if (!componentDef) { //if no variable is binded or empty dataset is binded then return back
      return;
    }
    if (index !== this.selectedIndex) {
      let previousSelected = this.liveWidgetSettingsService.selectedComponent[componentType];
      if (!isEmpty(previousSelected)) {
        let itemIndex = this.liveWidgetSettingsService.componentDefnObject[componentType].findIndex((comp: any) => comp.key === previousSelected.key);
        if (itemIndex !== -1) {
          this.liveWidgetSettingsService.componentDefnObject[componentType][itemIndex] = previousSelected;
        }
      }
    }
    this.liveWidgetSettingsService.componentDefnObject.isLayout = componentDef.isRowOperation;
    this.liveWidgetSettingsService.selectedComponent[componentType] = componentDef;
    this.setCustomPipeConfig(componentDef.formatpattern);
    this.updateFormatPattern(componentDef.formatpattern);
    if (componentType === 'field') {
      this.liveWidgetUtils.setColumnConfig(this.liveWidgetSettingsService.selectedComponent[componentType]);
      this.liveWidgetSettingsService.setDragHandle($event);
      this.onDataSetChange();
      this.onFilterDataSetChange();
      //Generate the group list options
      this.groupList = this.getExistingGroupNames(this.liveWidgetSettingsService.headerConfig, componentDef.field);
      this.setParentGroupName(this.liveWidgetSettingsService.headerConfig, this.liveWidgetSettingsService.selectedComponent.field);
      this.liveWidgetSettingsService.showGroupByProperties(this.liveWidgetSettingsService.selectedComponent.field);
    }
    if (componentDef.widgetType === 'wm-table-column') {
      componentDef.widgetType = undefined;
    }

    // for actions update ngclasses array(it is an internal propery used to show conditional class field)
    if (componentType === 'button') {
      componentDef.ngClasses = this.liveWidgetUtils.parseNgClasses(componentDef.conditionalclass);
    }
    if (this.liveWidgetSettingsService.selectedComponent.field.customExpression === "") {
      this.liveWidgetSettingsService.selectedComponent.field.customExpression = undefined
    }


    this.liveWidgetSettingsService.focusSelectedComponent();
    if (this.liveWidgetSettingsService.activeWidgetScope.editmode !== 'form' && this.liveWidgetSettingsService.activeWidgetScope.editmode !== 'dialog') {
      this.events = this.getEvents(componentDef.editWidgetType);
    }




    this.updateSelectedFieldColumns();
    this.selectedIndex = isDefined(index) ? index : undefined;
    this.selectedComponentType = componentType;
    this.updateGroupList();
  };

  /**
 * query builder need the filter fields upon which user builds a query.
 * In this case when you are selecting a particular entity, just filter out all the other entity columns and show only
 * those columns required for the selected field.
 */
  updateSelectedFieldColumns = () => {
    var variable = this.liveWidgetSettingsService.activeWidgetScope.variable;
    if (variable && variable.category === "wm.LiveVariable" && variable.operation === "read") {
      this.selectedFieldColumns = this.dialogDesigner.getCriteriaFilterFields(this.dialogDesigner.getTypeForTheEntity(variable, this.liveWidgetSettingsService.selectedComponent.field.relatedEntityName));
    }
  };

  getEvents(widget: any) {
    let wps = this.liveWidgetUtils.getWidgetProps(widget || 'text'),
      events: any = [];
    forEach(wps, (value, key) => {
      if (value?.type === 'event' && value?.show) {
        events.push(key);
      }
    });
    return events;
  }


  //Set the parent group name on field/ group
  setParentGroupName(headerConfig: any, columnDef: any, parentField?: any, parentDisplayName?: any) {
    var index = findIndex(headerConfig, columnDef);
    //If field is found, set the parent group name. Else, search for inner nodes.
    if (index > -1) {
      columnDef.parentGroup = parentField ? { 'field': parentField, 'displayName': parentDisplayName } : {};
      return false;
    }
    forEach(headerConfig, (config) => {
      if (config.columns) {
        this.setParentGroupName(config.columns, columnDef, config.field, config.displayName);
      }
    });
    return
  }

  //Function to get the existing group names. These names are used to generate new unique group name
  getExistingGroupNames(headerConfig: any, groupField?: any) {
    var groupNames: any = [];
    forEach(headerConfig, (config: any) => {
      //If same group, skip the inner groups to prevent showing up in group list
      if (config.isGroup && config.field !== groupField) {
        groupNames.push({
          'field': config.field,
          'displayName': config.displayName
        });
        groupNames = groupNames.concat(this.getExistingGroupNames(config.columns, groupField));
      }
    });
    return groupNames;
  }

  // Looping through the custom pipes and generating the modal properties.
  setCustomPipeConfig = (exp: any) => {
    if (exp == 'custompipe') {
      this.liveWidgetSettingsService.selectedComponent.field.formatpattern = '';
      this.liveWidgetSettingsService.saveDesignerSettings();
      // $rootScope.$broadcast('wms:edit-formatter-js'); // TODO: check how to emit value to root
      return;
    }
    if (!this.customPipeOptions || !this.customPipeOptions[exp] || !this.customPipeOptions[exp].config) {
      return;
    }
    for (var key in this.customPipeOptions[exp].config) {
      this.liveWidgetSettingsService.selectedComponent.field[this.customPipeOptions[exp]?.config[key]?.name] = this.liveWidgetSettingsService.selectedComponent.field[this.customPipeOptions[exp]?.config[key]?.name] || this.customPipeOptions[exp]?.config[key]?.value;
    }
  };


  // For custompipes assigning the arguments from the user config.
  updateFormatPattern = (expr: any) => {
    if (expr == 'custompipe') {
      return;
    }
    if (!this.customPipeOptions) {
      return;
    }
    var selectedCustomPipe = this.customPipeOptions[expr];
    if (selectedCustomPipe) {
      var customPipeFormat = "custom : '" + this.liveWidgetSettingsService.selectedComponent.field.formatpattern + "'";
      for (var key in selectedCustomPipe.config) {
        customPipeFormat = customPipeFormat + ":'" + this.liveWidgetSettingsService.selectedComponent.field[selectedCustomPipe.config[key].name] + "'";
      }
      this.liveWidgetSettingsService.selectedComponent.field.custompipeformat = customPipeFormat;

    } else {
      this.liveWidgetSettingsService.selectedComponent.field.custompipeformat = undefined;
    }
  }

  //On dataset change of a field, populate the datafield and display field options
  onDataSetChange() {
    var field = this.liveWidgetSettingsService.selectedComponent.field,
      widget = field.editWidgetType,
      dataSetWidgets = this.liveWidgetSettingsService.isDatasetWidgets[widget],
      relatedKey = last(split(field.field, '.')),
      selectedDataSet = field.dataset,
      dataSetFields;
    if (isEmpty(field)) {
      return;
    }
    if (selectedDataSet) {
      field.filterOn = undefined;
    }
    this.liveWidgetSettingsService.matchModes = getMatchModes();
    field.matchmodeShow = false;
    var isBoundToVariable = stringStartsWith(selectedDataSet, 'bind:Variables.');
    if (isBoundToVariable) {
      var variable = this.liveWidgetSettingsService.activeWidgetScope.variable;
      if (variable && variable.category === 'wm.LiveVariable') {
        field.matchmodeShow = true;

        // set default matchmode when no value is set.
        if (!field.matchmode) {
          field.matchmode = 'startignorecase';
        }
      } else if (field.matchmode) { // empty matchmode when dataset is set other than liveVariable
        field.matchmode = '';
      }
    }
    //If the the dataset is empty or not bound, remove the display and datafield options
    if (!stringStartsWith(selectedDataSet, 'bind:')) {
      if (dataSetWidgets && field.relatedEntityName && field.primaryKey) {
        dataSetFields = this.typeService.getFieldsForExpr(this.liveWidgetSettingsService.activeWidgetScope.binddataset + '.' + head(split(field.field, '.')));
        this.displayfieldArray = dataSetFields;
        this.datafieldArray = ['All Fields'].concat(dataSetFields);
        if (widget === 'select') {
          field.datafield = field.datafield || relatedKey;
          field.displayfield = field.displayfield || relatedKey;
        } else if (widget === 'autocomplete') {
          field.datafield = field.datafield || relatedKey;
          field.searchkey = field.searchkey || relatedKey;
          field.displaylabel = field.displaylabel || relatedKey;
        }
        this.groupbyDisplayOptions = this.dialogDesigner.getGroupbyDisplayOptions(this.displayfieldArray);
        return;
      }
      this.datafieldArray = [];
      this.displayfieldArray = [];
      this.groupbyDisplayOptions = [];
      field.displayfield = field.searchkey = field.displaylabel = field.datafield = undefined;
      return;
    }
    if (dataSetWidgets) {
      dataSetFields = this.typeService.getFieldsForExpr(selectedDataSet) || [];
      this.displayfieldArray = dataSetFields;
      this.datafieldArray = ['All Fields'].concat(dataSetFields);
      this.groupbyDisplayOptions = this.dialogDesigner.getGroupbyDisplayOptions(this.displayfieldArray);
    }
  }

  //On filter dataset change of a field, populate the datafield and display field options
  onFilterDataSetChange() {
    var field = this.liveWidgetSettingsService.selectedComponent?.field,
      widget = field?.filterwidget,
      dataSetWidgets = this.liveWidgetSettingsService.isDatasetWidgets?.[widget],
      selectedDataSet = field.filterdataset,
      dataSetFields;
    if (isEmpty(field)) {
      return;
    }
    //If the the dataset is empty or not bound, remove the display and datafield options
    if (!stringStartsWith(selectedDataSet, 'bind:')) {
      this.filterDatafieldArray = [];
      this.filterDisplayfieldArray = [];
      field.filterdisplayfield = field.filtersearchkey = field.filterdisplaylabel = field.filterdatafield = undefined;
      return;
    }
    if (dataSetWidgets) {
      field.filteronfilter = undefined;
      dataSetFields = this.typeService.getFieldsForExpr(selectedDataSet) || [];
      this.filterDisplayfieldArray = dataSetFields;
      this.filterDatafieldArray = ['All Fields'].concat(dataSetFields);
    }
  }

  widgetChange(widget: any) {
    let field = this.liveWidgetSettingsService.selectedComponent.field,
      removeProps = ['defaultvalue', 'editdatepattern', 'maxchars', 'regexp', 'minvalue', 'maxvalue', 'required', 'dataset',
        'step',
        'checkedvalue', 'uncheckedvalue', 'showdropdownon', 'dataentrymode', 'autoclose', 'datafield', 'displayfield', 'searchkey', 'displaylabel',
        'validationmessage'];
    forEach(removeProps, (prop) => {
      field[prop] = undefined;
    });
    field.editinputtype = 'text';
    this.events = this.getEvents(widget);
    //Do not set the default dataset and data field for grid bound to live variable
    if (field.dataset || field.relatedEntityName || this.isBoundToLiveVariable) {
      return;
    }
    if (widget === 'select') {
      field.dataset = this.liveWidgetSettingsService.activeWidgetScope.binddataset;
      field.datafield = field.displayfield = field.field;
    } else if (widget === 'autocomplete') {
      field.dataset = this.liveWidgetSettingsService.activeWidgetScope.binddataset;
      field.datafield = field.searchkey = field.displaylabel = field.field;
    }
  };


  //Set access roles on the column/ button
  setAccessRoles(colDef: any) {
    // TODO: access role implementation is pending
    colDef.accessroles = colDef.accessroles ? getWidgetRolesArrayFromStr(colDef.accessroles) : this.everyoneRole;
  }

  //Function to copy the properties form component definition to header config.
  populateHeaderConfig(headerConfig: any) {
    forEach(headerConfig, (config) => {
      var columnDef;
      if (config.isGroup) {
        //to remove the row expansion column
        remove(config.columns, { 'isPredefined': true });
        this.populateHeaderConfig(config.columns);
        this.setAccessRoles(config);
      } else {
        columnDef = find(this.liveWidgetSettingsService.componentDefnObject.field, { 'field': config.field });
        if (columnDef) {
          //Set the column def properties on header config. Header config is used in dialog to modify properties.
          columnDef.fieldName = config.field;
          extend(config, columnDef);
        }
      }
    });
  }

  //On opening advanced settings, select the first field and default
  selectFirstComponents() {
    if (isEmpty(this.liveWidgetSettingsService.selectedComponent?.field)) {
      //select the first column by default
      this.updateSelectedComponent(this.liveWidgetSettingsService?.headerConfig?.[0], 'field', 0);
    }
    if (isEmpty(this.liveWidgetSettingsService.selectedComponent?.button)) {
      //select the first button by default
      this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject?.button?.[0], 'button', 0);
      if (isEmpty(this.liveWidgetSettingsService.selectedComponent?.button)) {
        //select the first button by default
        this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject?.rowActions?.[0], 'button', 0);
      }
    }

    //check if select all should be selected
    this.liveWidgetSettingsService.updateSelectAll('button', 'include');
    this.liveWidgetSettingsService.updateSelectAll('field', 'pcDisplay');
    this.liveWidgetSettingsService.updateSelectAll('field', 'mobileDisplay');
    this.liveWidgetSettingsService.updateSelectAll('field', 'tabletDisplay');
  }

  /*function to load the respective partial params when content is changed*/
  contentChange = (partialName: any, isOnLoad?: any) => {
    var partiaParams = get(this.projectService.getPageInfo(partialName), 'params'),
      paramName;
    if (!isOnLoad) {
      this.liveWidgetSettingsService.componentDefnObject.rowDef.partialParams = [];
    }

    // loop over each partial param, and append a property object against the widget scope
    forEach(partiaParams, (param) => {
      paramName = param.name;
      if (!find(this.liveWidgetSettingsService.componentDefnObject.rowDef.partialParams, { name: paramName })) {
        this.liveWidgetSettingsService.componentDefnObject.rowDef.partialParams.push({ 'name': param.name, 'value': '', 'type': param.type });
      }
    });
    //Remove the deleted params and load the existing params on to the page
    remove(this.liveWidgetSettingsService.componentDefnObject.rowDef.partialParams, (isparam: any) => {
      return !find(partiaParams, (param) => {
        return isparam.name === param.name;
      });
    });
  };


  changeGroup(groupField: any) {
    let groupLength,
      index = findIndex(this.liveWidgetSettingsService.headerConfig, { 'field': this.liveWidgetSettingsService.selectedComponent.field.field });
    //First, remove field from the present group
    this.removeFromGroup(this.liveWidgetSettingsService.headerConfig);
    //If moved inside a group, add it to the group
    if (groupField) {
      this.addToGroup(this.liveWidgetSettingsService.headerConfig, groupField);
    } else {
      if (index === -1) {
        //Else, add it to the first level. Check for the last included element
        groupLength = filter(this.liveWidgetSettingsService.headerConfig, (config) => {
          return config.mobileDisplay || config.tabletDisplay || config.pcDisplay || config.isGroup;
        }).length;
      } else {
        //If item is present at top level and user clicked on clear, do nothing.
        groupLength = index;
      }
      this.liveWidgetSettingsService.headerConfig.splice(groupLength, 0, this.liveWidgetSettingsService.selectedComponent.field);
    }
    this.liveWidgetSettingsService.focusSelectedComponent(true);
  }

  removeFromGroup(headerConfig: any): any {
    let selectedField = this.liveWidgetSettingsService.selectedComponent.field,
      index = findIndex(headerConfig, selectedField);
    //If field is found, remove it. Else, search in inner nodes.
    if (index > -1) {
      headerConfig.splice(index, 1);
      return false;
    }
    forEach(headerConfig, (config) => {
      if (config.columns) {
        this.removeFromGroup(config.columns);
      }
    });
  }

  addToGroup(headerConfig: any, groupField: any): any {
    //If group is found, push field in to the group. Else, search for inner nodes.
    let group = find(headerConfig, function (config) {
      return config.columns && config.field === groupField;
    });
    if (group) {
      group.columns.push(this.liveWidgetSettingsService.selectedComponent.field);
      return false;
    }
    forEach(headerConfig, (config) => {
      if (config.columns) {
        this.addToGroup(config.columns, groupField);
      }
    });
  }

  updateSearchKey = (event: any) => {
    this.actionSearchKey = event.searchKey;
  }

  navigateToScript(fname: any) {
    this.liveWidgetSettingsService.saveDesignerSettings(true)
  }

// Method to filter out Actions/Operation columns added in the table (ex: Actions, Radio, Select all rows etc.)
  isNotRowOperation = (col: any) => {
    return col.field !== 'rowOperations' && !col.isPredefined;
  }


}
